import { Modal } from 'components/layout/Modal'
import { FortySecondProgressBar } from 'components/progressbar/FortySecondProgressBar'
import React from 'react'

export const VoiceCloningWait = (props: any) => {
  const { isModalOpen, setIsModalOpen, userVoiceRefetch } = props
  return (
    <Modal isModal={isModalOpen}>
      <div className="w-[335px] bg-[white] h-[200px] rounded-[20px] flex flex-col py-8 px-6 gap-6">
        <p className="font-bold text-[18px]">🗣️ 내 목소리 만드는 중...</p>
        <p className="text-[14px]">1~3분 정도만 기다려주세요!</p>
        <FortySecondProgressBar
          onComplete={() => {
            userVoiceRefetch()
            setIsModalOpen(false)
          }}
        />
      </div>
    </Modal>
  )
}
